import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("textarea", {
  id: "baiduLayeditID",
  name: "content",
  style: {"width":"100%","height":"400px"}
}, null, -1)

import { reactive, onMounted, onUnmounted } from 'vue';
  import { layer } from '@layui/layer-vue';
  import { addAnnouncement, getAnnouncement } from '../../api';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'announcement',
  setup(__props) {

  const model = reactive({
    title: '',
    content: ''
  });
  
  let ue: any = null;
  
  onMounted(() => {
    if (typeof UE === 'undefined') {
      console.error('UEditor script not loaded');
      return;
    }
  
    // 初始化 UEditor
    ue = UE.getEditor('baiduLayeditID');
  
    ue.ready(() => {
      // 在编辑器准备好后设置内容
      ue.setContent(model.content);
    });
  
    // 获取公告数据
    allAnnouncement();
  });
  
  onUnmounted(() => {
    if (ue) {
      ue.destroy(); // 销毁编辑器实例
      ue = null;
    }
  });
  
  const allAnnouncement = async () => {
    try {
      const res = await getAnnouncement();
      if (res && res.code === 0) {
        model.title = res.data.title;
        model.content = res.data.content;
        if (ue) {
          ue.setContent(res.data.content); // 更新编辑器内容
        }
      }
    } catch (error) {
      console.error('Error fetching announcement:', error);
    }
  };
  
  const submit = async () => {
    if (ue) {
      model.content = ue.getContent(); // 获取编辑器内容
      try {
        const res = await addAnnouncement(model);
        if (res && res.code === 0) {
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      } catch (error) {
        console.error('Error submitting announcement:', error);
      }
    } else {
      console.error('UEditor is not initialized');
    }
  };
  
return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_panel = _resolveComponent("lay-panel")!

  return (_openBlock(), _createBlock(_component_lay_panel, null, {
    default: _withCtx(() => [
      _createVNode(_component_lay_form, { model: model }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_form_item, {
            label: "公告标题",
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_input, {
                modelValue: model.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.title) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_lay_form_item, {
            label: "公告内容",
            prop: "content"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_lay_form_item, { style: {"text-align":"center"} }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_button, {
                type: "primary",
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提交")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }))
}
}

})